export default __webpack_public_path__ + "static/media/chillingbreath.e9deb2af.png";